import {
  TaxTraxResult,
  GetDriversResult,
  AvailableMunicipalities,
} from './models';
import { Nullable } from 'common';
import { USStates } from 'common/models';

export const GET_TAXTRAX_STATES_SUCCESS = 'GET_TAXTRAX_STATES_SUCCESS';
export const SET_TAXTRAX_LOADING = 'SET_TAXTRAX_LOADING';
export const GET_AVAILABLE_MUNICIPALITIES_SUCCESS =
  'GET_AVAILABLE_MUNICIPALITIES_SUCCESS';
export const SET_AVAILABLE_MUNICIPALITIES_LOADING =
  'SET_AVAILABLE_MUNICIPALITIES_LOADING';
export const SET_AVAILABLE_MUNICIPALITIES_MODAL_VISIBILITY =
  'SET_AVAILABLE_MUNICIPALITIES_MODAL_VISIBILITY';
export const GET_TAXTRAX_DRIVERS_SUCCESS = 'GET_TAXTRAX_DRIVERS_SUCCESS';
export const RESET_TAXTRAX_DRIVERS_DATA = 'RESET_TAXTRAX_DRIVERS_DATA';
export const RESET_TAXTRAX_RESULTS = 'RESET_TAXTRAX_RESULTS';
export const TAXTRAX_RESULT_SUCCESS = 'TAXTRAX_RESULT_SUCCESS';

export interface TaxTraxState {
  loading: boolean;
  usStates: Nullable<USStates>;
  result: Nullable<TaxTraxResult>;
  driversData: Nullable<GetDriversResult>;
  availableMunicipalities: Nullable<AvailableMunicipalities>;
  showAvailableMunicipalitiesModal: boolean;
  availableMunicipalitiesLoading: boolean;
}

export interface SetResultLoadingType {
  type: typeof SET_TAXTRAX_LOADING;
  loading: boolean;
}

export interface SetAvailableMunicipalitiesLoadingType {
  type: typeof SET_AVAILABLE_MUNICIPALITIES_LOADING;
  availableMunicipalitiesLoading: boolean;
}

export interface SetAvailableMunicipalitiesModalType {
  type: typeof SET_AVAILABLE_MUNICIPALITIES_MODAL_VISIBILITY;
  showAvailableMunicipalitiesModal: boolean;
}

export interface GetAvailableMunicipalitiesSuccessType {
  type: typeof GET_AVAILABLE_MUNICIPALITIES_SUCCESS;
  availableMunicipalities: AvailableMunicipalities;
}

/* GET_STATES */

export interface GetStatesSuccessType {
  type: typeof GET_TAXTRAX_STATES_SUCCESS;
  usStates: USStates;
}

/* GET_DRIVERS */

export interface GetDriversSuccessType {
  type: typeof GET_TAXTRAX_DRIVERS_SUCCESS;
  driversData: GetDriversResult;
}

export interface SearchResultSuccessType {
  type: typeof TAXTRAX_RESULT_SUCCESS;
  result: TaxTraxResult;
}

export interface ResetDriversDataType {
  type: typeof RESET_TAXTRAX_DRIVERS_DATA;
}

export interface ResetResultsType {
  type: typeof RESET_TAXTRAX_RESULTS;
}

export type TaxTraxTypes =
  | GetStatesSuccessType
  | SetResultLoadingType
  | GetAvailableMunicipalitiesSuccessType
  | SetAvailableMunicipalitiesLoadingType
  | SetAvailableMunicipalitiesModalType
  | GetDriversSuccessType
  | SearchResultSuccessType
  | ResetDriversDataType
  | ResetResultsType;
